export default __webpack_public_path__ + "static/media/12.e46625a0.png";